import {
  AgeAdjustment as CoreAgeAdjustment,
  type AgeAdjustmentProps as CoreAgeAdjustmentProps,
} from '@zealth/core/adjustments'

import { BaseAdjustment } from './BaseAdjustment'

/**
 * Web-bound `AgeAdjustment`: same as core's, but with the platform's
 * `BaseAdjustment` pre-injected so consumers don't have to thread it
 * through every call site.
 */
export type AgeAdjustmentProps = Omit<CoreAgeAdjustmentProps, 'BaseAdjustment'>

export const AgeAdjustment = (props: AgeAdjustmentProps) => (
  <CoreAgeAdjustment BaseAdjustment={BaseAdjustment} {...props} />
)
